import { render, staticRenderFns } from "./DepartmentSettings.vue?vue&type=template&id=33adf2fe&"
import script from "./DepartmentSettings.vue?vue&type=script&lang=js&"
export * from "./DepartmentSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports